'use client'

import {useChunkLoadRecovery} from '@/lib/use-chunk-load-recovery'

/**
 * Global Error Boundary - Renders outside the root layout
 * Must include its own <html> and <body> tags.
 * Minimal version to avoid SSG prerendering issues.
 *
 * Fängt auch Chunk-Ladefehler aus dem Root-Layout selbst (lazy geladene
 * Provider/Monitor). Für die wird einmal hart neu geladen, siehe
 * lib/chunk-load-error.ts; erst beim zweiten Scheitern erscheint diese Seite.
 */
export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    const reloading = useChunkLoadRecovery(error)

    if (reloading) {
        return (
            <html lang="de">
                <body/>
            </html>
        )
    }

    return (
        <html lang="de">
            <body style={{
                margin: 0,
                fontFamily: 'system-ui, -apple-system, sans-serif',
                backgroundColor: '#f9fafb',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '1rem'
            }}>
                <div style={{
                    maxWidth: '28rem',
                    width: '100%',
                    textAlign: 'center',
                    backgroundColor: 'white',
                    borderRadius: '0.75rem',
                    padding: '2rem',
                    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)'
                }}>
                    <h1 style={{
                        fontSize: '1.25rem',
                        fontWeight: 600,
                        color: '#1f2937',
                        marginBottom: '0.75rem'
                    }}>
                        Entschuldigung!
                    </h1>
                    <p style={{
                        color: '#6b7280',
                        fontSize: '0.875rem',
                        marginBottom: '1.5rem',
                        lineHeight: 1.5
                    }}>
                        Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
                    </p>
                    <button
                        onClick={() => reset()}
                        style={{
                            padding: '0.625rem 1rem',
                            backgroundColor: '#f59e0b',
                            color: 'white',
                            border: 'none',
                            borderRadius: '0.375rem',
                            fontSize: '0.875rem',
                            fontWeight: 500,
                            cursor: 'pointer'
                        }}
                    >
                        Erneut versuchen
                    </button>
                </div>
            </body>
        </html>
    )
}
